export default "__VITE_ASSET__BjFF35Bb__"